import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "../ui/card";
import { Skeleton } from "../ui/skeleton";
import { MessageSquare } from "lucide-react";
import { ActionMenu } from "../shared/ActionMenu";
import { CommentDetailPopover } from "../shared/CommentDetailPopover";

const colorCodedReadingEase = (item) => {
    if (item.reading_ease == null) return <span className="text-muted-foreground">—</span>;
    const cls = item.reading_ease > 60 ? 'text-green-600 font-bold' :
                item.reading_ease >= 30 ? 'text-orange-500 font-bold' :
                'text-red-600 font-bold';
    return <span className={cls}>{item.reading_ease.toFixed(1)}</span>;
};

const CommentCards = ({
    items,
    loading = false,
    onEdit,
    onDeleteRequest
}) => {
    if (!loading && items.length === 0) {
        return null;
    }

    return (
        <div className="grid grid-cols-1 gap-4 md:hidden">
            {loading ? (
                Array.from({ length: 3 }).map((_, i) => (
                    <Card key={`skeleton-${i}`}>
                        <CardContent className="space-y-2 pt-0">
                            <Skeleton className="h-6 w-3/4 mb-2" />
                            <Skeleton className="h-4 w-1/2 mb-1" />
                            <Skeleton className="h-4 w-1/3" />
                        </CardContent>
                    </Card>
                ))
            ) : (
                items.map((item) => (
                    <Card key={item.comment_id} id={`comment-${item.comment_id}`} className="transition-all duration-200">
                        <CardHeader>
                            <CardTitle className="text-base font-bold flex items-center gap-2">
                                <MessageSquare className="h-4 w-4 text-muted-foreground" />
                                {item.fk_stock_symbol}
                            </CardTitle>
                            <CardDescription>
                                <span className="text-xs block">{item.predictorname || 'Nom inconnu'}</span>
                                <CommentDetailPopover comment={item}>
                                    <a
                                        href={`#comment-${item.comment_id}`}
                                        className="text-xs text-primary underline hover:text-primary/80 block"
                                    >
                                        {item.created_at ? new Date(item.created_at).toLocaleDateString('fr-FR') : '—'}
                                    </a>
                                </CommentDetailPopover>
                            </CardDescription>
                        </CardHeader>
                        <CardContent className="space-y-2 pt-0">
                            <p className="text-sm line-clamp-3">{item.comment_text}</p>
                            <div className="grid grid-cols-3 gap-2 text-xs">
                                <div><span className="text-muted-foreground">Direction:</span> {item.direction}</div>
                                <div><span className="text-muted-foreground">Time:</span> {typeof item.time_frame === 'string' ? item.time_frame : JSON.stringify(item.time_frame)}</div>
                                <div><span className="text-muted-foreground">Change:</span> {item.percentage_change != null ? `${item.percentage_change}%` : '—'}</div>
                            </div>
                            <div className="flex items-center gap-4 text-xs">
                                <div>Reading Ease: {colorCodedReadingEase(item)}</div>
                                <div>Grade Level: {item.grade_level != null ? item.grade_level.toFixed(1) : <span className="text-muted-foreground">—</span>}</div>
                            </div>
                        </CardContent>
                        <CardFooter className="flex justify-end pt-0">
                            <ActionMenu
                                onEdit={() => onEdit(item)}
                                onDelete={() => onDeleteRequest(item.comment_id)}
                            />
                        </CardFooter>
                    </Card>
                ))
            )}
        </div>
    );
};

export default CommentCards;
